import React from "react";
import { Link } from "react-router-dom";

export default function StatCard({ label, value, sub, accent, to }) {
  const content = (
    <div
      className={`bg-white border border-zinc-200 rounded-sm p-5 sm:p-6 transition-colors ${
        to ? "hover:border-zinc-900 cursor-pointer" : "hover:border-zinc-400"
      }`}
      data-testid={`stat-${label.toLowerCase().replace(/\s+/g, "-")}`}
    >
      <div className="text-[10px] uppercase tracking-[0.25em] text-zinc-500 mb-2">
        {label}
      </div>
      <div
        className="text-3xl sm:text-4xl font-black tracking-tighter text-zinc-900"
        style={{ fontFamily: "Manrope, sans-serif" }}
      >
        {value}
      </div>
      {sub && (
        <div className={`text-xs mt-2 ${accent ? "text-[#E60000] font-semibold" : "text-zinc-500"}`}>
          {sub}
        </div>
      )}
    </div>
  );

  if (!to) {
    return content;
  }

  return (
    <Link to={to} className="block rounded-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900">
      {content}
    </Link>
  );
}
